import AssetPreferences from './AssetPreferences'
export default AssetPreferences
